import { Label as AriaLabel } from 'react-aria-components';

export function Label({ children, ...props }) {
  return (
    <AriaLabel
      {...props}
      className="empty:hidden mb-1 font-medium text-body-dark text-sm"
      elementType="label"
    >
      {children}
    </AriaLabel>
  );
}
